// Project Imports
import constants from 'core/constants/Constants';

const fileTypesMapping = {
  excel: [
    constants.XlsType,
    constants.XlsxType,
    constants.XlsWpsType,
    constants.CsvType,
  ],
  javascript: [constants.JsType],
  python: [constants.pythonDjangoType],
  Default: [constants.DmnType],
  image: [
    constants.png,
    constants.jpeg,
    constants.pdf,
    constants.tif,
    constants.tiff,
    constants.jpg,
  ],
};

export default fileTypesMapping;

const activeStatus = [
  { label: 'Active', value: true },
  { label: 'Inactive', value: false },
];

export { activeStatus };

const ConfigurationStatus = [
  { label: 'Configure', value: true },
  { label: 'Enter Amount', value: false },
];

export { ConfigurationStatus };

const AddDmnAndFormula = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export { AddDmnAndFormula };

const clawbackTypeOptions = [
  { label: 'Recalculation', value: 'RECALCULATION' },
  { label: 'Reverse Calculation', value: 'FULL' },
  { label: 'Partial Clawback', value: 'PARTIAL' },
];

export { clawbackTypeOptions };
